import type { paths } from "./schema";

/**
 * Every API path the portal calls, in one place (DECISIONS.md §2.10). Typed against the backend's OpenAPI,
 * so a path that no longer exists fails the build.
 */
export const ENDPOINTS = {
  session: "/v1/auth/session",
  me: "/v1/me",
  adminOverview: "/v1/admin/overview",
  adminAnalyticsSummary: "/v1/admin/analytics/summary",
  adminAnalyticsPlans: "/v1/admin/analytics/plans",
  adminBrands: "/v1/admin/brands",
  adminBrand: "/v1/admin/brands/{brandId}",
  adminBrandStatus: "/v1/admin/brands/{brandId}/status",
  adminBrandTeam: "/v1/admin/brands/{brandId}/team",
  adminBrandOwnerInvitation: "/v1/admin/brands/{brandId}/owner-invitation",
  adminBrandCommissionTerms: "/v1/admin/brands/{brandId}/commission-terms",
  adminBrandPayoutPolicies: "/v1/admin/brands/{brandId}/payout-policies",
  adminBrandMealSlots: "/v1/admin/brands/{brandId}/meal-slots",
  adminBrandMealSlot: "/v1/admin/brands/{brandId}/meal-slots/{slotId}",
  adminBrandMealSlotOrder: "/v1/admin/brands/{brandId}/meal-slots/order",
  adminSettings: "/v1/admin/settings",
  adminSetting: "/v1/admin/settings/{key}",
  adminUsers: "/v1/admin/users",
  adminUser: "/v1/admin/users/{userId}",
  adminUserRestore: "/v1/admin/users/{userId}/restore",
  adminSubscriptions: "/v1/admin/subscriptions",
  adminSubscription: "/v1/admin/subscriptions/{subscriptionId}",
  adminSubscriptionBonusMeals: "/v1/admin/subscriptions/{subscriptionId}/bonus-meals",
  adminSubscriptionCancel: "/v1/admin/subscriptions/{subscriptionId}/cancel",
  adminSubscriptionRemoveMeals: "/v1/admin/subscriptions/{subscriptionId}/remove-meals",
  adminSubscriptionMealsLeft: "/v1/admin/subscriptions/{subscriptionId}/meals-left",
  adminSubscriptionMovePlan: "/v1/admin/subscriptions/{subscriptionId}/move-plan",
  adminSubscriptionQuote: "/v1/admin/subscriptions/quote",
  adminBrandPlans: "/v1/admin/brands/{brandId}/plans",
  adminBrandSettings: "/v1/admin/brands/{brandId}/settings",
  adminBrandPlan: "/v1/admin/brands/{brandId}/plans/{planId}",
  adminUserAddresses: "/v1/admin/users/{userId}/addresses",
  adminDisputes: "/v1/admin/disputes",
  adminDisputeResolve: "/v1/admin/disputes/{disputeId}/resolve",
  adminPayments: "/v1/admin/payments",
  adminPayment: "/v1/admin/payments/{paymentId}",
  adminPaymentRefunds: "/v1/admin/payments/{paymentId}/refunds",
  adminRefunds: "/v1/admin/refunds",
  adminPayoutsDue: "/v1/admin/payouts/due",
  adminPayouts: "/v1/admin/payouts",
  adminPayout: "/v1/admin/payouts/{payoutId}",
  adminPayoutPaid: "/v1/admin/payouts/{payoutId}/paid",
  adminPayoutFailed: "/v1/admin/payouts/{payoutId}/failed",
  adminPayoutAccountNumber: "/v1/admin/payouts/{payoutId}/account-number",
  adminLedger: "/v1/admin/ledger",
  adminReconciliation: "/v1/admin/reconciliation",
  adminPromoCodes: "/v1/admin/promo-codes",
  adminPromoCode: "/v1/admin/promo-codes/{promoId}",
  adminDispatchTemplates: "/v1/admin/dispatch-templates",
  adminDispatchTemplate: "/v1/admin/dispatch-templates/{templateId}",
  adminAuditLogs: "/v1/admin/audit-logs",
  adminReviews: "/v1/admin/reviews",
  adminReviewVisibility: "/v1/admin/reviews/{reviewId}/visibility",
} as const satisfies Record<string, keyof paths>;
